import request from '@/utils/request'

// 查询森林省份列表
export function listForestProvince(query) {
  return request({
    url: '/admin/forest/province/list',
    method: 'get',
    params: query
  })
}

// 查询森林省份详细
export function getForestProvince(provinceId) {
  return request({
    url: '/admin/forest/province/getInfo?provinceId=' + provinceId,
    method: 'get'
  })
}

// 新增森林省份
export function addForestProvince(data) {
  return request({
    url: '/admin/forest/province',
    method: 'post',
    data: data
  })
}

// 修改森林省份
export function updateForestProvince(data) {
  return request({
    url: '/admin/forest/province',
    method: 'put',
    data: data
  })
}

// 删除森林省份
export function delForestProvince(provinceId) {
  return request({
    url: '/admin/forest/province/deleteProvince?provinceId=' + provinceId,
    method: 'delete'
  })
}

// 获取森林省份选择框列表
export function optionSelect() {
  return request({
    url: '/admin/forest/province/optionSelect',
    method: 'get'
  })
}
